import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';

import style from './EventItem.css'
import ThreadsIcon from '../Icons/ThreadsIcon';
import PersonsIcon from '../Icons/PersonsIcon';

export default class EventItem extends PureComponent {
  render() {
    let {event} = this.props;

    return (
        <div className={style.item}>
          <h4 className={style.title}>
            <a href={'/events/' + event.id}>
              {event.title}
            </a>

            {/*<Link to={'/events/' + event.id}>*/}
            {/*  {event.title}*/}
            {/*</Link>*/}
          </h4>
          <p className={style.summary}>
            {event.description}
          </p>
          <div className={style.footer}>
            <ThreadsIcon size={14} />
            {event.threads_count}
            &nbsp; &nbsp;
            <PersonsIcon size={14} />
            {event.persons.length}
          </div>
        </div>
    )
  }
}
